export default __webpack_public_path__ + "static/media/Rahul (1).6212d1d8.png";